import { app_domain, getAtelierHost, production } from 'app/config/constants'

const PROD_DOMAIN = production ? app_domain === 'atelier' ? getAtelierHost() : 'dresscode.ai' : undefined
const ZERO = new Date(0).toUTCString()
const YEAR = 365 * 24 * 60 * 60

export function getCookie(name: string): string | undefined {
  const prefix = encodeURIComponent(name) + '='
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const trimmed = cookie.trimStart()
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length))
    }
  }
  return undefined
}

// Куку пишем только на проде, поэтому и читать её можно только там: на stage
// прод-кука с общего домена dresscode.ai видна, но очистить её оттуда нельзя —
// и удалённый пользователь возвращался бы из неё при каждом старте.
export function getProdCookie(name: string): string | undefined {
  return production ? getCookie(name) : undefined
}

export function setProdCookie(name: string, value: string | undefined): void {
  if (production) setCookie(name, value, PROD_DOMAIN)
}

export function setCookie(name: string, value: string | undefined, domain?: string): void {
  const parts = [encodeURIComponent(name) + '=' + encodeURIComponent(value ?? '')]
  parts.push('path=/')
  if (domain) parts.push('domain=' + domain)
  if (value === undefined) parts.push('expires=' + ZERO)
  else parts.push('max-age=' + YEAR)
  parts.push('SameSite=Lax')
  if (location.protocol === 'https:') parts.push('Secure')
  document.cookie = parts.join('; ')
}

export function deleteAllCookies() {
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.split('=')[0]!.trim()
    document.cookie = name + '=; path=/; expires=' + ZERO
    document.cookie = name + '=; path=/; domain=' + PROD_DOMAIN + '; expires=' + ZERO
    document.cookie = name + '=; expires=' + ZERO
  })
}
